export default __webpack_public_path__ + "static/media/serpantin_left.ae417d2d.svg";